// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3vWp7","pendingPaymentIcon":"CalendarEvent_pendingPaymentIcon__VF359","gfeWrapper":"CalendarEvent_gfeWrapper__24qyU"};